import React from "react";
import Icon from "../Icon";

export const Loading = ({show}) => {
    return (
        <div className={`loading ${show ? 'show' : 'hide'}`}>
            <Icon name="loading" className="spin" />
        </div>
    );
}